<template>
	<div class="bg-white rounded-xl mt-6 shadow divide-y divide-gray-200">
		<!-- list header-->
		<div
			class="rounded-t-xl text-gray-700 px-3 py-2 flex justify-between items-center bg-gray-100 gap-x-2"
		>
			<h3 class="text-xl font-medium">{{ matchTitle }}</h3>
			<!-- font-medium hover:bg-gray-100 rounded-lg text-gray-500
            active:bg-gray-150 focus:gray-400 focus:ring-2 ring-gray-500-->

			<!-- sort by -->
			<span class="w-100 ml-auto mr-3">
				<ui-select
					class="text-sm"
					v-model="sortOrder"
					:options="sortOrderOptions"
					:allow-empty="false"
					@change="page = 1"
				/>
			</span>

			<!-- Sammelgebot -->
			<page-link
				:href="
					$route('bid.createBulk', {
						sourceType: offer.trade,
						sourceId: offer.id,
					})
				"
				v-if="offer.trade == 'BUY'"
				:absolute="true"
				class="truncate bg-orange-500 text-sm text-white px-4 py-1.5 font-medium rounded-lg focus:ring-2 focus:ring-orange-200 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-orange-400 border border-transparent shadow-sm hover:bg-orange-600 focus:outline-none font-medium"
				>
				{{ __("Bulk bid") }}
			</page-link>

			<!-- <button class v-on:click.stop="$emit('close')">
                <ui-icon class="h-5 w-5 text-orange" name="x" stroke-width="2.5" />
            </button> -->
		</div>

		<!-- list matching items -->
		<ul class="divide-y divide-gray-200">
			<li class v-for="match in currentPageMatches" :key="match.id">
				<match-details-short
					:match="match"
					:offer="offer"
					:key="match.id"
					:showQuality="false"
				/>
			</li>
		</ul>

		<!-- pagination -->
		<div
			class="rounded-b-xl px-3 py-3 flex items-center justify-between bg-gray-100"
			v-if="numPages > 1"
		>
			<!-- to do style mobile
                <div class="flex-1 flex justify-between sm:hidden">
                    <a href="#" class="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
                    Previous
                    </a>
                    <a href="#" class="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
                    Next
                    </a>
            </div>-->
			<div class="hidden sm:block">
				<p class="text-sm text-gray-700">
					{{
						__("messages.start_to_end", {
							args: {
								start: (page - 1) * perPage + 1,
								end: (page - 1) * perPage + currentPageMatches.length,
								total: sortedMatches.length,
							},
						})
					}}
				</p>
			</div>

			<div class="flex-1 flex justify-between sm:justify-end">
				<span
					v-for="p in pageRange"
					:key="'page_' + p"
					v-on:click="page = p"
					:class="[
						'ml-3 relative inline-flex items-center px-3 py-1.5 border text-sm font-medium rounded-md cursor-pointer',
						p == page
							? 'bg-green-500 border-green-500 text-green-100'
							: 'text-gray-500 bg-white hover:bg-gray-50',
					]"
					>{{ p }}</span
				>
			</div>
			<!-- <div>
                        <nav class="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
                            <a href="#" class="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-200 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
                                <span class="sr-only">Previous</span>
                                <ui-icon class="h-5 w-5" name="chevron-left" stroke-width="2" />
                            </a>
                            <a href="#" aria-current="page" class="z-10 bg-green-500 border-green-500 text-green-100 relative inline-flex items-center px-4 py-2 border text-sm font-medium">
                            1
                            </a>
                            <a href="#" class="bg-white border-gray-200 text-gray-500 hover:bg-gray-50 relative inline-flex items-center px-4 py-2 border text-sm font-medium">
                            2
                            </a>
                            <a href="#" class="bg-white border-gray-200 text-gray-500 hover:bg-gray-50 hidden md:inline-flex relative items-center px-4 py-2 border text-sm font-medium">
                            3
                            </a>
                            <span class="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700">
                            ...
                            </span>
                            <a href="#" class="bg-white border-gray-200 text-gray-500 hover:bg-gray-50 hidden md:inline-flex relative items-center px-4 py-2 border text-sm font-medium">
                            8
                            </a>
                            <a href="#" class="bg-white border-gray-200 text-gray-500 hover:bg-gray-50 relative inline-flex items-center px-4 py-2 border text-sm font-medium">
                            9
                            </a>
                            <a href="#" class="bg-white border-gray-200 text-gray-500 hover:bg-gray-50 relative inline-flex items-center px-4 py-2 border text-sm font-medium">
                            10
                            </a>
                            <a href="#" class="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-200 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
                                <span class="sr-only">Next</span>
                                <ui-icon class="h-5 w-5" name="chevron-right" stroke-width="2" />
                            </a>
                        </nav>
            </div>-->
		</div>
	</div>
</template>

<script>
export default {
	props: {
		offer: {
			type: Object,
			required: true,
		},
		newMatches: {
			type: Array,
			required: true,
		},
	},
	data() {
		let perPage = 5;

		return {
			page: 1,
			perPage: perPage,
			numPages: Math.ceil(this.newMatches.length / perPage),
			sortOrder:
				this.offer.trade == "BUY" ? "price_estimate" : "price_estimate_HIGH",
			sortOrderOptions: [
				{
					id: "relevance",
					label: "Relevance",
				},
				{
					id: "distance_km_road",
					label: "Shortest distance",
				},
				{
					id: "updated_at",
					label: "Newest listing",
				},
				{
					id: "price_estimate",
					label: "Lowest price",
				},
				{
					id: "price_estimate_HIGH",
					label: "Highest price",
				},
			],
		};
	},
	computed: {
		sortedMatches() {
			let that = this;
			return _.sortBy(this.newMatches, [
				function (match) {
					if (that.sortOrder == "updated_at") {
						return match.offer.updated_at;
					} else if (that.sortOrder == "price_estimate_HIGH") {
						return -1 * match.price_estimate;
					} else {
						return match[that.sortOrder];
					}
				},
			]);
		},
		currentPageMatches() {
			return this.sortedMatches
				.slice((this.page - 1) * this.perPage)
				.slice(0, this.perPage);
		},
		pageRange() {
			return _.range(1, this.numPages + 1);
		},
		matchTitle() {
			return (
				(this.offer.trade == "BUY"
					? this.__("Matching offer")
					: this.__("Matching demand")) +
				(this.offer.user.type == "FARMER"
					? " " +
					  this.$cropOptions.getLocalizedLabel(
							this.offer.location.mode,
							this.$cropOptions.locationModeOptions
					  ) +
					  " " +
					  this.offer.location.address.city
					: "")
			);
		},
	},
};
</script>
